<!-- ================首页-听评课详情====================-->
<template>
    <div class="tea-eva-lesson-info-page">
        <home-head />
        <div class="tea-eva-lesson-body">
            <div class="tea-eva-lesson-inner">
                <!-- 标题区 -->
                <div class="page-header">
                    <div class="page-title-box">
                        <div class="page-title">听评课详情</div>
                        <div class="page-subtitle">{{ lessonInfo.title || '--' }}</div>
                    </div>
                    <div class="page-actions">
                        <div class="back-btn" @click="goBack">
                            <span>返回列表</span>
                        </div>
                    </div>
                </div>

                <div class="content-layout">
                    <!-- 左侧模块 -->
                    <div class="content-main">
                <!-- 基本信息 -->
                <div class="info-section">
                    <div class="section-header">
                        <div class="section-title-group">
                            <div class="section-title">基本信息</div>
                            <div class="info-status-bar">
                                <span class="status-tag" :class="statusClass(lessonInfo.status)">{{ formatStatus(lessonInfo.status) }}</span>
                            </div>
                        </div>
                        <div class="section-extra">
                            <div class="info-actions">
                                <el-popover v-if="canFillScale" placement="bottom-start" trigger="hover" :width="'auto'">
                                    <div>
                                        <div class="scale-item"
                                             v-for="item in lessonInfo.scaleList"
                                             :key="item.scaleId"
                                             :title="item.title"
                                             @click="handleComplete(item)">
                                            <span :style="item.isSub === 1 ? '' : 'color: #b22222'">{{ item.isSub === 1 ? '已提交' : '请填写' }}-{{ item.title }}</span>
                                        </div>
                                    </div>
                                    <template #reference>
                                        <span class="action-btn">填写量表</span>
                                    </template>
                                </el-popover>
                                <span class="action-btn" v-if="lessonInfo.status !== 1 && lessonInfo.role === 3" @click="handleSummary">评课总结</span>
                                <span class="action-btn" v-if="lessonInfo.status === 2 && canManage" @click="handleStop">停止评课</span>
                                <span class="action-btn" v-if="!lessonInfo.lessonVideoUrl && lessonInfo.status === 3 && lessonInfo.role === 0" @click="isShowLessonVideo = true">上传实录</span>
                            </div>
                        </div>
                    </div>
                    <div class="base-info-content">
                        <div class="info-main">
                            <div class="info-title">[听评课]{{ lessonInfo.title || '--' }}</div>
                            <div class="info-row">
                                <span class="info-label">市区县：</span>
                                <span class="info-value">{{ lessonInfo.countyName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">学校名称：</span>
                                <span class="info-value">{{ lessonInfo.schoolName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">学科信息：</span>
                                <span class="info-value">{{ lessonInfo.periodName || '--' }}、{{ lessonInfo.gradeName || '--' }}、{{ lessonInfo.subjectName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">听课性质：</span>
                                <span class="info-value">{{ formatLessonNature(lessonInfo.lessonNature) }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.groupName">
                                <span class="info-label">工作室/群组：</span>
                                <span class="info-value">{{ lessonInfo.groupName }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">听课类型：</span>
                                <span class="info-value">{{ formatEvaType(lessonInfo.type) }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">授课老师：</span>
                                <span class="info-value">{{ lessonInfo.lectureTeacherName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">指导专家：</span>
                                <span class="info-value">{{ lessonInfo.guideExpertTxt || '暂无' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.listenTeacherTxt">
                                <span class="info-label">听课老师：</span>
                                <span class="info-value">{{ lessonInfo.listenTeacherTxt }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.rateTeacherTxt">
                                <span class="info-label">评课老师：</span>
                                <span class="info-value">{{ lessonInfo.rateTeacherTxt }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">听课时段：</span>
                                <span class="info-value">{{ formatTimeRange(lessonInfo) }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">评课截止：</span>
                                <span class="info-value">{{ lessonInfo.rateEndTime ? timestampToTime(lessonInfo.rateEndTime) : '--' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.type === 0">
                                <span class="info-label">听课地址：</span>
                                <span class="info-value">{{ lessonInfo.address || '--' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.type === 1 || lessonInfo.type === 2">
                                <span class="info-label">听课地址：</span>
                                <span class="info-value">
                                    <span class="go-lesson-btn" @click="beginLesson">去听课</span>
                                </span>
                            </div>
                        </div>
                        <div class="info-cover">
                            <img class="img-100" :src="lessonInfo.coverUrl || defaultCover" alt="听评课封面" />
                        </div>
                    </div>
                </div>

                <!-- 邀请码 -->
                <div class="info-section" v-if="lessonInfo.status && lessonInfo.status !== 3">
                    <div class="section-title" style="margin-bottom: 16px;">邀请码</div>
                    <div class="qrcode-container">
                        <div class="code-item">
                            <div class="code-title">听课邀请码</div>
                            <div class="code-img" @click="handleTkDownload">
                                <el-tooltip effect="dark" content="点击下载二维码" placement="bottom">
                                    <vueQr ref="tkcode" :text="qrCode.shareTkUrl" :size="qrCode.size" :margin="qrCode.margin" />
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="code-item">
                            <div class="code-title">评课邀请码</div>
                            <div class="code-img" @click="handlePkDownload">
                                <el-tooltip effect="dark" content="点击下载二维码" placement="bottom">
                                    <vueQr ref="pkcode" :text="qrCode.sharePkUrl" :size="qrCode.size" :margin="qrCode.margin" />
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="code-item">
                            <div class="code-title">专家邀请码</div>
                            <div class="code-img" @click="handleZjDownload">
                                <el-tooltip effect="dark" content="点击下载二维码" placement="bottom">
                                    <vueQr ref="zjcode" :text="qrCode.shareZjUrl" :size="qrCode.size" :margin="qrCode.margin" />
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 地图位置 -->
                <div class="info-section" v-if="lessonInfo.type === 0">
                    <div class="section-title" style="margin-bottom: 16px;">地图位置</div>
                    <div class="map-container">
                        <aMap isDetail v-if="isShowMap" ref="zdyMap"
                              @getGeocoder="getGeocoder"
                              :oldCenter="oldCenter"
                              :isShowAMap="true">
                        </aMap>
                    </div>
                </div>

                <!-- 听课量表 -->
                <div class="info-section" v-if="lessonInfo.scaleList && lessonInfo.scaleList.length > 0">
                    <div class="section-title" style="margin-bottom: 16px;">听课量表</div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in lessonInfo.scaleList" :key="item.scaleId">
                            <span class="file-name" :title="item.title">
                                {{ item.title }}
                                <span class="scale-state" :class="{ sub: item.isSub === 1 }">{{ item.isSub === 1 ? '（已提交）' : '（待填写）' }}</span>
                            </span>
                            <div class="file-actions">
                                <span class="file-action" @click="handleComplete(item)">{{ item.isSub === 1 ? '查看' : '填写' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 备课文件 -->
                <div class="info-section" v-if="lessonInfo.lessonFileList && lessonInfo.lessonFileList.length > 0">
                    <div class="section-title" style="margin-bottom: 16px;">备课文件</div>
                    <div class="file-list">
                        <div class="file-item" v-for="(item, index) in lessonInfo.lessonFileList" :key="index">
                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                            <div class="file-actions">
                                <span class="file-action" @click="viewFile(item)">预览</span>
                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- AI评估报告 -->
                <div class="info-section" v-if="canViewReport && lessonInfo.fxbgFileList && lessonInfo.fxbgFileList.length > 0">
                    <div class="section-title" style="margin-bottom: 16px;">AI评估报告</div>
                    <div class="file-list">
                        <div class="file-item" v-for="(item, index) in lessonInfo.fxbgFileList" :key="index">
                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                            <div class="file-actions">
                                <span class="file-action" @click="viewFile(item)">预览</span>
                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 专家报告 -->
                <div class="info-section" v-if="canViewReport && lessonInfo.expertFileList && lessonInfo.expertFileList.length > 0">
                    <div class="section-title" style="margin-bottom: 16px;">专家报告</div>
                    <div class="file-list">
                        <div class="file-item" v-for="(item, index) in lessonInfo.expertFileList" :key="index">
                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                            <div class="file-actions">
                                <span class="file-action" @click="viewFile(item)">预览</span>
                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 课堂实录 -->
                <div class="info-section" v-if="canViewReport && lessonInfo.lessonVideoUrl">
                    <div class="section-title" style="margin-bottom: 16px;">课堂实录</div>
                    <div class="file-list">
                        <div class="file-item">
                            <span class="file-name">课堂实录</span>
                            <div class="file-actions">
                                <span class="file-action" @click="viewVideo">播放</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 附件内容 -->
                <div class="info-section" v-if="lessonInfo.fileList && lessonInfo.fileList.length > 0">
                    <div class="section-title" style="margin-bottom: 16px;">附件内容</div>
                    <div class="file-list">
                        <div class="file-item" v-for="(item, index) in lessonInfo.fileList" :key="index">
                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                            <div class="file-actions">
                                <span class="file-action" @click="viewFile(item)">预览</span>
                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                            </div>
                        </div>
                    </div>
                </div>

                    </div>
                    <!-- 讨论区（右侧） -->
                    <div class="content-side">
                <div class="info-section discuss-section">
                    <div class="section-title" style="margin-bottom: 16px;">讨论区</div>
                    <div class="discuss-input-box" v-if="isShowDiscuss">
                        <el-input type="textarea"
                                  :rows="3"
                                  resize="none"
                                  placeholder="请输入讨论内容"
                                  v-model="discussWordContent"
                                  class="discuss-info-input">
                        </el-input>
                        <div class="discuss-btn-box">
                            <el-upload class="discuss-uploader"
                                       :action="serviceUrl + '/businessservice/evaluation/discussAnnex'"
                                       :show-file-list="false"
                                       :on-success="handleUploadFileSuccess"
                                       :headers="{ token }"
                                       accept=".doc,.docx,.ppt,.pptx,.pdf"
                                       :before-upload="beforeFileUpload">
                                <span class="discuss-upload-btn">上传附件</span>
                            </el-upload>
                            <el-upload class="discuss-uploader"
                                       :action="serviceUrl + '/businessservice/evaluation/discussAnnex'"
                                       :show-file-list="false"
                                       :on-success="handleUploadImageSuccess"
                                       :headers="{ token }"
                                       accept=".png,.jpeg,.jpg"
                                       :before-upload="beforeImageUpload">
                                <span class="discuss-upload-btn">上传图片</span>
                            </el-upload>
                            <span class="action-btn" @click="submitDiscuss">发表</span>
                        </div>
                    </div>
                    <div class="discuss-list" v-if="discussList.length > 0">
                        <div class="discuss-one" v-for="(item, index) in discussList" :key="index">
                            <div class="discuss-user-avatar">
                                <img class="discuss-user-avatar-img" alt="头像" @error="onImageError" :src="item.avatar" />
                            </div>
                            <div class="discuss-user-content">
                                <div class="user-info">
                                    <span class="user-true-name">{{ item.createUserName }}</span>
                                    <span class="user-role">{{ formatRoleType(item.roleType) }}</span>
                                    <span class="content-time">{{ timestampToTime(item.createTime) }}</span>
                                </div>
                                <div class="content-info" v-if="item.discussType === 1">{{ item.content }}</div>
                                <div class="img-info" v-if="item.discussType === 2">
                                    <el-image alt="" :src="item.imgContent" :preview-src-list="item.imgList" fit="cover" />
                                </div>
                                <div class="audio-info" v-if="item.discussType === 3">
                                    <audio controls controlslist="nodownload noplaybackrate">
                                        <source type="audio/wav" :src="item.audioContent" />
                                    </audio>
                                </div>
                                <div class="file-info" v-if="item.discussType === 4 && item.file">
                                    <div class="file-box">
                                        <img class="file-type-icon" alt="" :src="fileTypeIcon(item.file)" @click="previewDiscussFile(item.file)" />
                                        <div class="file-detail">
                                            <div class="name-box" @click.stop="handleDownload(item.file.fileUrl, item.file.fileName)">{{ item.file.fileName }}</div>
                                            <div class="size-box">
                                                <span class="size-num">{{ item.file.fileSize }}</span>
                                                <img class="download-icon" alt="下载" src="@/assets/icon/img/download.png" @click.stop="handleDownload(item.file.fileUrl, item.file.fileName)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-discuss" v-else>
                        <div class="empty-icon">
                            <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                        </div>
                        <div class="empty-text">暂无数据</div>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 量表填写/查看 -->
        <el-dialog :title="previewData.title ? previewData.title : '量表预览'" v-model="previewShow" width="60%">
            <previewData :disabled="disabled" ref="editData" v-if="previewShow" :previewData="previewData" :isHide="isHide" />
            <template #footer v-if="!disabled">
                <el-button @click="closePreview">取 消</el-button>
                <el-button type="primary" @click="submitPreviewForm">确 定</el-button>
            </template>
        </el-dialog>

        <!-- 听评课总结 -->
        <el-dialog title="听评课总结" v-model="isShowSum" width="44%" align-center class="sum-info">
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教学内容">
                            <el-input type="textarea" resize="none" placeholder="请填写教学内容方面总结" v-model="summaryForm.teachContent" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教学方法">
                            <el-input type="textarea" resize="none" placeholder="请填写教学方法方面总结" v-model="summaryForm.teachMethod" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课堂氛围">
                            <el-input type="textarea" resize="none" placeholder="请填写课堂氛围方面总结" v-model="summaryForm.classroomMood" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="sum-group-title">教师行为</div>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="激发兴趣">
                            <el-input type="textarea" resize="none" placeholder="请填写激发兴趣方面总结" v-model="summaryForm.teaInterest" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="达标意识">
                            <el-input type="textarea" resize="none" placeholder="请填写达标意识方面总结" v-model="summaryForm.teaAware" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="引导体验">
                            <el-input type="textarea" resize="none" placeholder="请填写引导体验方面总结" v-model="summaryForm.teaExperience" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="评价反馈">
                            <el-input type="textarea" resize="none" placeholder="请填写评价反馈方面总结" v-model="summaryForm.teaFeedback" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="讲授指导">
                            <el-input type="textarea" resize="none" placeholder="请填写讲授指导方面总结" v-model="summaryForm.teaGuide" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="sum-group-title">学生行为</div>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="参与状态">
                            <el-input type="textarea" resize="none" placeholder="请填写参与状态方面总结" v-model="summaryForm.stuStatus" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="参与广度">
                            <el-input type="textarea" resize="none" placeholder="请填写参与广度相关总结" v-model="summaryForm.stuScope" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="有效思维">
                            <el-input type="textarea" resize="none" placeholder="请填写有效思维方面总结" v-model="summaryForm.stuThink" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合作效果">
                            <el-input type="textarea" resize="none" placeholder="请填写合作效果方面总结" v-model="summaryForm.stuResult" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="目标达成">
                            <el-input type="textarea" resize="none" placeholder="请填写目标达成方面总结" v-model="summaryForm.stuAim" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="师生关系">
                            <el-input type="textarea" resize="none" placeholder="请填写师生关系方面总结" v-model="summaryForm.teaStuRelation" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="其他内容">
                            <el-input type="textarea" resize="none" placeholder="请填写其他总结内容" v-model="summaryForm.otherContent" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <el-button @click="closeSummary">取 消</el-button>
                <el-button type="primary" @click="submitSummary">确 定</el-button>
            </template>
        </el-dialog>

        <!-- 上传课堂实录 -->
        <el-dialog title="课堂实录" v-model="isShowLessonVideo" width="35%">
            <el-upload ref="videoUpload"
                       v-model:file-list="videoList"
                       style="width: 100%"
                       class="upload-demo"
                       :auto-upload="true"
                       :limit="1"
                       drag
                       accept=".MP4,.mp4"
                       :before-upload="handleBeforeUpload"
                       :http-request="handleCourseUpload">
                <div class="el-upload__text">
                    将文件拖拽到此处或<em>点击上传</em>
                </div>
                <template #tip>
                    <div class="el-upload__tip">
                        只允许上传一个MP4格式文件,且大小不超过4G。
                    </div>
                </template>
            </el-upload>
            <template #footer>
                <el-button @click="isShowLessonVideo = false">取 消</el-button>
                <el-button type="primary" @click="submitEvaVideo">确 定</el-button>
            </template>
        </el-dialog>

        <!-- 课堂实录播放 -->
        <el-dialog @close="closeIframe" :title="'课堂实录'" v-model="isViewVideo" width="80%" top="50px">
            <iframe id="evaVideo" style="width: 100%; height: calc(100vh - 150px)" :src="lessonInfo.lessonVideoUrl" frameborder="0"></iframe>
        </el-dialog>

        <!-- 线上听课 -->
        <el-dialog @close="gbIfram" :title="'线上听课'" v-model="isTk" width="80%" top="50px">
            <iframe id="cktpkfx" style="width: 100%; height: calc(100vh - 250px)" :src="lessonInfo.address" frameborder="0"></iframe>
        </el-dialog>

        <!-- 附件预览 -->
        <el-image-viewer
            v-if="previewVisible"
            :url-list="previewSrcList"
            :initial-index="0"
            :hide-on-click-modal="true"
            @close="previewVisible = false"
        />

        <!-- 视频上传进度遮罩 -->
        <div class="loading-overlay" v-if="loadingVisible">
            <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="8"></el-progress>
            <p class="loading-tips">上传中，请等待...</p>
        </div>
    </div>
</template>

<script>
import vueQr from "vue-qr/src/packages/vue-qr.vue";
import html2canvas from "html2canvas";
import { ElLoading, ElImageViewer } from "element-plus";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";
import { serviceUrl, serviceWebUrl, ossClient } from "@/utils/global";
import { getFileNameUUID, signatureUrl } from "@/utils/tools";
import {
    evaluationInfo,
    evaluationStop,
    rateScaleInfo,
    rateRecordScore,
    rateRecordScoreInfo,
    listEvaDiscuss,
    submitEvaDiscuss,
    infoLessonSummary,
    createOrUpdateLessonSummary,
    evaLessonVideo,
} from "@/api/admin/evaluation";
import homeHead from "@/components/common/homeHead.vue";
import previewData from "@/components/previewData.vue";
import aMap from "@/components/aMap/index.vue";

/* 分片大小配置（MB） */
const SHARD_SIZE_CONFIG = {
    SMALL: 1, // < 200MB
    MEDIUM: 2, // < 1024MB
    LARGE: 5, // < 2048MB
    X_LARGE_RATIO: 500, // >= 2048MB
};

export default {
    components: { homeHead, previewData, aMap, vueQr, ElImageViewer },
    name: "teaEvaLessonInfo",
    data() {
        return {
            timestampToTime,
            serviceUrl,
            token: this.$storage.get("token"),
            role: this.$storage.get("role"),
            userId: JSON.parse(this.$storage.get("userInfo") || "{}").userId,
            loading: false,
            lessonId: "",
            defaultCover: require("@/assets/logo/logo.png"),
            currentTime: new Date().getTime(),
            isShowMap: false,
            isShowDiscuss: false,
            oldCenter: [],
            lessonInfo: {
                title: "",
                countyName: "",
                schoolName: "",
                periodName: "",
                gradeName: "",
                subjectName: "",
                lessonNature: "",
                groupName: "",
                type: 0,
                address: "",
                lng: "",
                lat: "",
                beginTime: "",
                endTime: "",
                rateEndTime: "",
                status: "",
                role: "",
                createUser: "",
                coverUrl: "",
                lectureTeacherName: "",
                guideExpertTxt: "",
                listenTeacherTxt: "",
                rateTeacherTxt: "",
                lessonVideoUrl: "",
                scaleList: [],
                lessonFileList: [],
                fxbgFileList: [],
                expertFileList: [],
                fileList: [],
                rateTeacherList: [],
                listenTeacherList: [],
                guideExpertList: [],
            },
            qrCode: {
                shareTkUrl: "",
                sharePkUrl: "",
                shareZjUrl: "",
                size: 100,
                margin: 5,
            },
            // 讨论区
            discussType: 1, // 研讨内容类型：1-文字 2-图片 3-音频 4-附件
            discussWordContent: "",
            wordContent: "",
            imgContent: "",
            fileContent: "",
            discussList: [],
            // 量表填写
            disabled: true,
            isHide: false,
            previewData: {},
            previewShow: false,
            // 听评课总结
            isShowSum: false,
            summaryForm: {
                lessonId: "",
                teachContent: "",
                teachMethod: "",
                classroomMood: "",
                teaInterest: "",
                teaAware: "",
                teaExperience: "",
                teaFeedback: "",
                teaGuide: "",
                stuStatus: "",
                stuScope: "",
                stuThink: "",
                stuResult: "",
                stuAim: "",
                teaStuRelation: "",
                otherContent: "",
            },
            // 课堂实录
            isShowLessonVideo: false,
            evaVideoForm: {
                lessonId: "",
                lessonVideoUrl: "",
            },
            videoList: [],
            isViewVideo: false,
            isTk: false,
            loadingVisible: false,
            loadingPercentage: 0,
            partItemSize: 5,
            // 附件预览
            previewVisible: false,
            previewSrcList: [],
        };
    },
    computed: {
        // 管理员或创建人可管理（停止评课）
        canManage() {
            return this.role === "1" || this.role === "2" || this.userId === this.lessonInfo.createUser;
        },
        // 管理员或授课人可查看报告与实录
        canViewReport() {
            return this.role == 1 || this.role == 2 || this.lessonInfo.role === 0;
        },
        // 可填写量表：授课人/评课人/评课组长且在评课截止时间内
        canFillScale() {
            const roles = [0, 1, 3];
            return (
                this.lessonInfo.scaleList &&
                this.lessonInfo.scaleList.length > 0 &&
                roles.includes(this.lessonInfo.role) &&
                Number(this.lessonInfo.rateEndTime) > this.currentTime
            );
        },
    },
    created() {
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId;
            this.qrCode.shareTkUrl = serviceWebUrl + "/inviteListen?lessonId=" + this.lessonId + "&type=1";
            this.qrCode.sharePkUrl = serviceWebUrl + "/inviteListen?lessonId=" + this.lessonId + "&type=2";
            this.qrCode.shareZjUrl = serviceWebUrl + "/inviteListen?lessonId=" + this.lessonId + "&type=3";
            this.queryLessonInfo();
            this.getDisList();
        }
    },
    mounted() {
        document.documentElement.classList.add("tea-eva-lesson-scroll");
        document.body.classList.add("tea-eva-lesson-scroll");
    },
    beforeUnmount() {
        document.documentElement.classList.remove("tea-eva-lesson-scroll");
        document.body.classList.remove("tea-eva-lesson-scroll");
    },
    methods: {
        /* ===============详情查询===================== */
        queryLessonInfo() {
            evaluationInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code === 1) {
                    const data = res.data.data || {};
                    data.rateTeacherTxt = (data.rateTeacherList || []).map(e => e.trueName).join("、");
                    data.listenTeacherTxt = (data.listenTeacherList || []).map(e => e.trueName).join("、");
                    if (!data.guideExpertTxt) {
                        data.guideExpertTxt = (data.guideExpertList || []).map(e => e.trueName).join("、");
                    }
                    this.lessonInfo = { ...this.lessonInfo, ...data };
                    this.currentTime = new Date().getTime();
                    this.isShowDiscuss = this.currentTime < Number(this.lessonInfo.rateEndTime) && this.lessonInfo.status !== 3;
                    // 地图
                    if (this.lessonInfo.type === 0) {
                        this.oldCenter = [this.lessonInfo.lng, this.lessonInfo.lat];
                        this.isShowMap = true;
                        setTimeout(() => {
                            if (this.$refs.zdyMap && this.oldCenter[0] && this.oldCenter[1]) {
                                this.$refs.zdyMap.center = this.oldCenter;
                                this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                            }
                        }, 100);
                    }
                } else {
                    this.$message.error(res.data.msg || "获取听评课信息失败");
                }
            }).catch(() => {});
        },

        /* ===============格式化===================== */
        formatStatus(status) {
            const map = {
                0: "未提请",
                1: "初始",
                2: "进行中",
                3: "已结束",
            };
            return map[status] || "--";
        },
        statusClass(status) {
            if (status === 3) return "status-end";
            if (status === 2) return "status-active";
            return "status-default";
        },
        formatLessonNature(val) {
            const map = {
                1: "普通",
                2: "名师工作室",
                3: "名校长工作室",
                4: "群组任务",
            };
            return map[val] || "普通";
        },
        formatEvaType(type) {
            const map = {
                0: "推门",
                1: "线上",
                2: "录播视频",
            };
            return map[type] || "--";
        },
        formatRoleType(roleType) {
            const map = {
                0: "授课人",
                1: "评课人",
                2: "听课人",
                3: "评课组长",
                4: "专家",
            };
            return map[roleType] || "";
        },
        formatTimeRange(row) {
            if (row.beginTime && row.endTime) {
                return timestampToTime(row.beginTime) + " 至 " + timestampToTime(row.endTime);
            }
            return "--";
        },
        goBack() {
            this.$router.push({ path: "/tea/teaResearch", query: { tab: "evaluation" } });
        },
        getGeocoder() {},

        /* ===============文件预览下载===================== */
        handleDownloadFile(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        handleDownload(fileUrl, fileName) {
            downloadFile(fileUrl, fileName);
        },
        viewFile(item) {
            if (item.status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览");
                return;
            }
            const previewList = this.gainFileImgList(item.imgUrl, item.pages);
            if (previewList && previewList.length > 0) {
                this.previewSrcList = previewList;
                this.previewVisible = true;
            } else if (item.fileUrl) {
                window.open(item.fileUrl, "_blank");
            } else {
                this.$message.info("暂无可预览内容");
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + "/" + i + ".png");
            }
            return list;
        },
        onImageError(e) {
            e.target.src = this.defaultCover;
        },

        /* ===============邀请码下载===================== */
        downloadQrCode(refName, fileName) {
            html2canvas(this.$refs[refName].$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300,
            }).then(canvas => {
                const imgUrl = canvas.toDataURL("image/png");
                const eleLink = document.createElement("a");
                eleLink.href = imgUrl;
                eleLink.download = (this.lessonInfo.title || "听评课") + "-" + fileName + ".png";
                eleLink.click();
            });
        },
        handleTkDownload() {
            this.downloadQrCode("tkcode", "听课邀请码");
        },
        handlePkDownload() {
            this.downloadQrCode("pkcode", "评课邀请码");
        },
        handleZjDownload() {
            this.downloadQrCode("zjcode", "专家邀请码");
        },

        /* ===============去听课===================== */
        beginLesson() {
            if (this.lessonInfo.type === 1) {
                this.viewZhiBo();
            } else {
                this.goTk();
            }
        },
        viewZhiBo() {
            const newDate = new Date().getTime();
            if (newDate > this.lessonInfo.beginTime && newDate < this.lessonInfo.endTime) {
                window.open(this.lessonInfo.address, "_blank");
            } else {
                this.$message.error("已过/未到任务时段中");
            }
        },
        goTk() {
            const newDate = new Date().getTime();
            if (newDate > this.lessonInfo.beginTime && newDate < this.lessonInfo.endTime) {
                this.isTk = true;
                setTimeout(() => {
                    const iframe = document.getElementById("cktpkfx");
                    if (iframe) iframe.setAttribute("src", this.lessonInfo.address);
                });
            } else {
                this.$message.error("已过/未到任务时段中");
            }
        },
        gbIfram() {
            const iframe = document.getElementById("cktpkfx");
            if (iframe) iframe.setAttribute("src", "");
        },

        /* ===============停止评课===================== */
        handleStop() {
            this.$confirm("确定停止当前听评课吗？", "提示", { type: "warning" }).then(() => {
                evaluationStop({ lessonId: this.lessonId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        this.$message.success("操作成功");
                        this.queryLessonInfo();
                    } else {
                        this.$message.error(res.data.msg || "操作失败");
                    }
                }).catch(() => {});
            }).catch(() => {});
        },

        /* ===============量表填写===================== */
        handleComplete(item) {
            // 授课人/评课人/评课组长可填写，其余仅查看
            const roles = [0, 1, 3];
            this.disabled = !roles.includes(this.lessonInfo.role);
            this.isHide = false;
            if (item.isSub == 1) {
                rateRecordScoreInfo({ lessonId: this.lessonId, scaleId: item.scaleId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        if (res.data.data.info.isHide == 1) {
                            this.isHide = true;
                        }
                        this.previewData = res.data.data.info;
                        (this.previewData.questionList || []).forEach(e => {
                            if (e.type == 2) {
                                e.questionAnswer = e.questionAnswer ? e.questionAnswer.split(",") : [];
                            }
                        });
                        this.previewShow = true;
                    } else {
                        this.$message.error(res.data.msg || "请求出错");
                    }
                }).catch(() => {});
            } else {
                rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                    if (res.data && res.data.code === 1) {
                        this.previewData = res.data.data;
                        (this.previewData.questionList || []).forEach(e => {
                            if (e.type == 2) {
                                e.questionAnswer = [];
                            } else {
                                e.questionAnswer = "";
                            }
                        });
                        this.previewShow = true;
                    } else {
                        this.$message.error(res.data.msg || "请求出错");
                    }
                }).catch(() => {});
            }
        },
        submitPreviewForm() {
            const preview = (this.$refs.editData && this.$refs.editData.previewData) || this.previewData;
            const obj = {};
            obj.scaleId = preview.scaleId;
            obj.lessonId = this.lessonId;
            obj.answerList = [];
            obj.isHide = this.$refs.editData && this.$refs.editData.isHide ? 1 : 0;
            let totalScore = 0;
            (preview.questionList || []).forEach(e => {
                if (e.type == 2) {
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: (e.questionAnswer || []).toString(),
                    });
                    (e.questionAnswer || []).forEach(m => {
                        (e.itemList || []).forEach(j => {
                            if (m == j.itemId) {
                                totalScore += Number(j.itemValue);
                            }
                        });
                    });
                } else {
                    if (e.type == 1) {
                        (e.itemList || []).forEach(j => {
                            if (e.questionAnswer == j.itemId) {
                                totalScore += Number(j.itemValue);
                            }
                        });
                    }
                    if (e.type == 3) {
                        totalScore += Number(e.questionAnswer || 0);
                    }
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: e.questionAnswer,
                    });
                }
            });
            obj.totalScore = totalScore;
            rateRecordScore(obj).then(res => {
                if (res.data && res.data.code == 1) {
                    this.previewShow = false;
                    this.isHide = false;
                    this.$message.success("提交成功");
                    this.queryLessonInfo();
                } else {
                    this.$message.error(res.data.msg || "提交失败");
                }
            }).catch(() => {});
        },
        closePreview() {
            this.previewShow = false;
        },

        /* ===============评课总结===================== */
        handleSummary() {
            this.isShowSum = true;
            infoLessonSummary({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code === 1 && res.data.data) {
                    this.summaryForm = { ...this.summaryForm, ...res.data.data };
                }
                this.summaryForm.lessonId = this.lessonId;
            }).catch(() => {
                this.summaryForm.lessonId = this.lessonId;
            });
        },
        closeSummary() {
            this.isShowSum = false;
        },
        submitSummary() {
            const fields = [
                "teachContent", "teachMethod", "classroomMood",
                "teaInterest", "teaAware", "teaExperience", "teaFeedback", "teaGuide",
                "stuStatus", "stuScope", "stuThink", "stuResult", "stuAim",
                "teaStuRelation", "otherContent",
            ];
            const hasContent = fields.some(f => this.summaryForm[f] && String(this.summaryForm[f]).trim() !== "");
            if (!hasContent) {
                this.$message.info("总结内容至少须填写一项");
                return;
            }
            this.summaryForm.lessonId = this.lessonId;
            createOrUpdateLessonSummary(this.summaryForm).then(res => {
                if (res.data && res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.isShowSum = false;
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            }).catch(() => {});
        },

        /* ===============课堂实录===================== */
        handleBeforeUpload(rawFile) {
            if (rawFile.type !== "video/mp4") {
                this.$message.error("不支持此类型文件");
                return false;
            } else if (rawFile.size / 1024 / 1024 / 1024 > 4) {
                this.$message.error("文件大小不能超过4G");
                return false;
            }
            const fs = rawFile.size / 1024 / 1024;
            this.partItemSize = this.calcShardSize(fs);
            return true;
        },
        calcShardSize(fileSize) {
            if (fileSize < 200) return SHARD_SIZE_CONFIG.SMALL;
            else if (fileSize < 1024) return SHARD_SIZE_CONFIG.MEDIUM;
            else if (fileSize < 2048) return SHARD_SIZE_CONFIG.LARGE;
            else return Math.ceil(fileSize / SHARD_SIZE_CONFIG.X_LARGE_RATIO);
        },
        handleCourseUpload(option) {
            const fileType = this.getFileName(option.file.name);
            const objName = getFileNameUUID() + fileType;
            this.loadingVisible = true;
            this.loadingPercentage = 0;
            this.multipartUpload("/ygjy/evaVideo/" + objName, option.file).then(() => {
                signatureUrl("/ygjy/evaVideo/" + objName).then(res => {
                    const lastQuestionMarkIndex = res.lastIndexOf("?");
                    let result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.evaVideoForm.lessonVideoUrl = result;
                    this.loadingVisible = false;
                }).catch(() => {
                    this.loadingVisible = false;
                });
            }).catch(() => {
                this.loadingVisible = false;
            });
        },
        async multipartUpload(objName, file) {
            try {
                return await ossClient.multipartUpload(`${objName}`, file, {
                    progress: p => {
                        this.loadingPercentage = parseInt(p * 100);
                    },
                    timeout: 600000000,
                    parallel: 6,
                    partSize: 1024 * 1024 * this.partItemSize,
                });
            } catch (e) {
                this.$message.error("上传失败");
                throw e;
            }
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));
        },
        submitEvaVideo() {
            if (!this.evaVideoForm.lessonVideoUrl) {
                this.$message.info("请上传课堂实录");
                return;
            }
            this.evaVideoForm.lessonId = this.lessonId;
            evaLessonVideo(this.evaVideoForm).then(res => {
                if (res.data && res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo();
                    this.isShowLessonVideo = false;
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            }).catch(() => {});
        },
        viewVideo() {
            this.isViewVideo = true;
            setTimeout(() => {
                const iframe = document.getElementById("evaVideo");
                if (iframe) iframe.setAttribute("src", this.lessonInfo.lessonVideoUrl);
            });
        },
        closeIframe() {
            const iframe = document.getElementById("evaVideo");
            if (iframe) iframe.setAttribute("src", "");
        },

        /* ===============讨论区===================== */
        getDisList() {
            listEvaDiscuss({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code === 1) {
                    this.discussList = res.data.data || [];
                }
            }).catch(() => {});
        },
        submitDiscuss() {
            const obj = {
                lessonId: this.lessonId,
                content: this.wordContent,
                imgContent: this.imgContent,
                fileContent: this.fileContent,
            };
            // 文字评论
            if (this.discussType === 1) {
                this.wordContent = this.discussWordContent;
                if (this.wordContent === "") {
                    this.$message.info("讨论内容不能为空");
                    return;
                }
                obj.content = this.wordContent;
                obj.imgContent = "";
                obj.fileContent = "";
            }
            // 图片评论
            if (this.discussType === 2) {
                if (this.imgContent === "") {
                    this.$message.info("研讨内容不能为空");
                    return;
                }
                obj.content = "";
                obj.imgContent = this.imgContent;
                obj.fileContent = "";
            }
            // 附件评论
            if (this.discussType === 4) {
                if (this.fileContent === "") {
                    this.$message.info("研讨内容不能为空");
                    return;
                }
                obj.content = "";
                obj.imgContent = "";
                obj.fileContent = this.fileContent;
            }
            const loading = ElLoading.service({ fullscreen: true });
            submitEvaDiscuss(obj).then(res => {
                loading.close();
                if (res.data && res.data.code === 1) {
                    this.$message.success("发表成功");
                    this.wordContent = "";
                    this.discussWordContent = "";
                    this.imgContent = "";
                    this.fileContent = "";
                    this.discussType = 1;
                    this.getDisList();
                } else {
                    this.$message.error(res.data.msg || "发表失败");
                    this.discussType = 1;
                }
            }).catch(() => {
                loading.close();
                this.discussType = 1;
            });
        },
        handleUploadImageSuccess(response, uploadFile) {
            if (uploadFile.response && uploadFile.response.code === 1) {
                this.imgContent = uploadFile.response.data;
                this.discussType = 2;
                this.submitDiscuss();
            } else {
                this.$message.error("上传失败");
            }
        },
        beforeImageUpload(rawFile) {
            if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error("图片大小不能超过10M");
                return false;
            }
            return true;
        },
        handleUploadFileSuccess(response, uploadFile) {
            if (uploadFile.response && uploadFile.response.code === 1) {
                this.fileContent = uploadFile.response.data;
                this.discussType = 4;
                this.submitDiscuss();
            } else {
                this.$message.error("上传失败");
            }
        },
        beforeFileUpload() {
            return true;
        },
        fileTypeIcon(file) {
            const type = file.fileType || "";
            if (this.comStr("pdf", type)) return require("@/assets/icon/img/file-pdf@3x.png");
            if (this.comStr("doc", type)) return require("@/assets/icon/img/file-doc@3x.png");
            if (this.comStr("ppt", type)) return require("@/assets/icon/img/file-ppt@3x.png");
            return require("@/assets/icon/img/file-unknown@3x.png");
        },
        previewDiscussFile(file) {
            const type = file.fileType || "";
            if (!this.comStr("pdf", type) && !this.comStr("doc", type) && !this.comStr("ppt", type)) {
                this.$message.info("该文件类型暂不支持预览");
                return;
            }
            if (file.status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览");
                return;
            }
            const previewList = this.gainFileImgList(file.imgUrl, file.pages);
            if (previewList && previewList.length > 0) {
                this.previewSrcList = previewList;
                this.previewVisible = true;
            } else {
                this.$message.info("暂无可预览内容");
            }
        },
        comStr(baseStr, type) {
            return type !== "" && type.toUpperCase().includes(baseStr.toUpperCase());
        },
    },
};
</script>

<style scoped>
.tea-eva-lesson-info-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto !important;
}

.tea-eva-lesson-body {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0 80px 0;
    box-sizing: border-box;
    overflow-y: auto !important;
}

.tea-eva-lesson-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.tea-eva-lesson-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.tea-eva-lesson-body::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.tea-eva-lesson-body::-webkit-scrollbar-thumb:hover {
    background: #9a1b1b;
}

.tea-eva-lesson-inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 左右分栏布局 */
.content-layout {
    width: 100%;
    display: flex;
    align-items: stretch;
    gap: 20px;
}

.content-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.content-side {
    width: 280px;
    flex-shrink: 0;
    position: relative;
}

/* 标题区 */
.page-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-title-box {
    display: flex;
    flex-direction: column;
}

.page-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.page-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.page-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 36px;
    line-height: 36px;
    padding: 0 32px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 信息区块 */
.info-section {
    width: 100%;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1.5px solid #b22222;
    padding: 20px;
    box-sizing: border-box;
}

.section-title {
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    flex-shrink: 0;
}

.section-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f3f4f6;
    margin-bottom: 16px;
}

.section-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.section-extra {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    flex: 1;
    min-width: 0;
}

.info-status-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.info-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 16px;
    background-color: #ffffff;
    color: #b22222;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 13px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

.status-tag {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 13px;
    font-size: 12px;
    color: #ffffff;
    font-family: sans-serif;
    background-color: #4095e5;
}

.status-tag.status-end {
    background-color: #81b337;
}

.status-tag.status-active {
    background-color: #ffbf6b;
}

.status-tag.status-default {
    background-color: #4095e5;
}

/* 基本信息 */
.base-info-content {
    width: 100%;
    display: flex;
    gap: 20px;
}

.info-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.info-title {
    font-size: 18px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
    line-height: 1.5;
    margin-bottom: 8px;
}

.info-row {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: sans-serif;
    line-height: 1.6;
}

.info-label {
    color: #4b5563;
    white-space: nowrap;
}

.info-value {
    color: #1f2937;
    flex: 1;
    word-break: break-all;
}

.go-lesson-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 0 18px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.go-lesson-btn:hover {
    background-color: #9a1b1b;
}

.info-cover {
    width: 300px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f3f4f6;
    align-self: flex-start;
}

.info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* 邀请码 */
.qrcode-container {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 60px;
}

.code-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.code-title {
    font-size: 14px;
    color: #4b5563;
    font-family: sans-serif;
}

.code-img {
    width: 110px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid #f3f4f6;
    border-radius: 4px;
    overflow: hidden;
}

/* 地图 */
.map-container {
    width: 100%;
    height: 350px;
}

/* 量表 */
.scale-item {
    padding: 6px 10px;
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
}

.scale-item:hover {
    background-color: #fff5f5;
}

.scale-state {
    font-size: 12px;
    color: #b22222;
}

.scale-state.sub {
    color: #9ca3af;
}

/* 文件列表 */
.file-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background-color: #f9fafb;
    border-radius: 4px;
}

.file-name {
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.file-action {
    font-size: 13px;
    color: #b22222;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.file-action:hover {
    color: #9a1b1b;
    text-decoration: underline;
}

/* 讨论区 */
.discuss-section {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
}

.discuss-input-box {
    width: 100%;
    margin-bottom: 16px;
    flex-shrink: 0;
}

.discuss-info-input {
    width: 100%;
}

.discuss-btn-box {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    width: 100%;
    flex-wrap: nowrap;
}

.discuss-btn-box .discuss-upload-btn {
    height: 26px;
    padding: 0 8px;
    font-size: 12px;
    flex-shrink: 0;
}

.discuss-btn-box .action-btn {
    height: 26px;
    padding: 0 10px;
    font-size: 12px;
    margin-left: auto;
    flex-shrink: 0;
}

.discuss-uploader {
    display: inline-flex;
}

.discuss-upload-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 16px;
    background-color: #ffffff;
    color: #4b5563;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 13px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.discuss-upload-btn:hover {
    color: #b22222;
    border-color: #b22222;
}

.discuss-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #b22222 #f1f1f1;
}

.discuss-list::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.discuss-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.discuss-list::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 3px;
}

.discuss-list::-webkit-scrollbar-thumb:hover {
    background: #9a1b1b;
}

.discuss-one {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.discuss-user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background-color: #f3f4f6;
}

.discuss-user-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.discuss-user-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.user-true-name {
    font-size: 14px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
}

.user-role {
    font-size: 12px;
    color: #b22222;
    font-family: sans-serif;
    padding: 1px 8px;
    border: 1px solid #b22222;
    border-radius: 10px;
}

.content-time {
    font-size: 12px;
    color: #9ca3af;
    font-family: sans-serif;
}

.content-info {
    font-size: 14px;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.6;
    word-break: break-all;
}

.img-info .el-image {
    max-width: 100%;
    border-radius: 4px;
}

.audio-info {
    width: 100%;
}

.audio-info audio {
    width: 100%;
    max-width: 100%;
    display: block;
}

.file-box {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background-color: #f9fafb;
    border-radius: 4px;
    max-width: 100%;
}

.file-type-icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    cursor: pointer;
}

.file-detail {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.name-box {
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.name-box:hover {
    color: #b22222;
}

.size-box {
    display: flex;
    align-items: center;
    gap: 8px;
}

.size-num {
    font-size: 12px;
    color: #9ca3af;
    font-family: sans-serif;
}

.download-icon {
    width: 14px;
    height: 14px;
    cursor: pointer;
}

/* 暂无数据 */
.empty-discuss {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
}

.empty-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 总结弹窗 */
.sum-group-title {
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    color: #1f2937;
    font-family: sans-serif;
    margin-bottom: 10px;
}

/* 上传遮罩 */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-tips {
    color: #ffffff;
    font-size: 14px;
    margin-top: 16px;
    font-family: sans-serif;
}

.img-100 {
    width: 100%;
    height: 100%;
}

/* 响应式 */
@media (max-width: 1024px) {
    .base-info-content {
        flex-direction: column;
    }

    .info-cover {
        width: 100%;
        max-height: 300px;
    }
}

@media (max-width: 768px) {
    .page-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .content-layout {
        flex-direction: column;
    }

    .content-side {
        width: 100%;
    }

    .discuss-section {
        position: static;
    }

    .discuss-list {
        max-height: 400px;
    }

    .info-section {
        padding: 14px;
    }

    .qrcode-container {
        gap: 20px;
        flex-wrap: wrap;
    }

    .file-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
}
</style>

<style>
html.tea-eva-lesson-scroll,
body.tea-eva-lesson-scroll {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

html.tea-eva-lesson-scroll::-webkit-scrollbar,
body.tea-eva-lesson-scroll::-webkit-scrollbar {
    display: none;
}
</style>
